
const AuthContainer = ({ children }) => {
    return (
        <div className="2xl:max-w-[335px] w-full max-w-[270px] mx-auto h-full flex flex-col justify-center items-center">
            <div className="flex flex-col gap-y-2">
                {children}
            </div>
        </div>
    )
}

export default AuthContainer;